// libs
import React, { Suspense, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
// actions
import { requestApi } from "./actions/apiCommon";
// constants
import { ROUTERS } from "./constants/routers";
// components
import LoadingPage from "./components/LoadingPage";
// utils
import { PrivateRoute } from "./utils/appRoutes";
// styles
import "./style/App.less";
// dynamic import
import DashboardLayoutContainer from "./containers/DashboardLayoutContainer";
import ErrorNotFoundContainer from "./containers/Error/ErrorNotFoundContainer";
import { requestInitialService } from "./actions/initialServiceActions";
import { REQUEST_META_DATA_SUCCESS } from "./constants/metaDataConstants";
import { requestForToken, onMessageListener } from "./firebase/messaging";
import { ConfigProvider } from "antd";
import viVN from "antd/es/locale/vi_VN";
import enUS from "antd/es/locale/en_US";
import jaJP from "antd/es/locale/ja_JP";

const { HOME, ERROR_GLITCH } = ROUTERS;

const App = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const basicProfileReducer = useSelector((state) => state.basicProfileReducer);
  const { userDetailInformation } = basicProfileReducer;
  const { initialServiceData } = useSelector(
    (state) => state.initialServiceReducer
  );
  const locale = {
    "vi-VN": viVN,
    "ja-JP": jaJP,
    "en-US": enUS,
  }[i18n.language];

  useEffect(() => {
    dispatch(requestApi.getBasicProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userDetailInformation) {
      dispatch(requestInitialService());

      //Firebase message
      requestForToken();
      onMessageListener();
    }
  }, [dispatch, userDetailInformation]);

  window.addEventListener("storage", (event) => {
    if (event?.newValue === null && event?.oldValue === null) {
      keycloak.logout();
    }
  });

  useEffect(() => {
    if (initialServiceData) {
      const [metaData] = initialServiceData;
      if (metaData && metaData.success) {
        dispatch({
          type: REQUEST_META_DATA_SUCCESS,
          payload: metaData.data.shiftTypes,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialServiceData]);

  useEffect(() => {
    if (userDetailInformation !== undefined) {
      const { language } = userDetailInformation;
      i18n.changeLanguage(language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetailInformation]);

  if (userDetailInformation === undefined) {
    return <LoadingPage />;
  }

  return (
    <ConfigProvider locale={locale}>
      <Suspense fallback={<LoadingPage />}>
        <Switch>
          <PrivateRoute path={HOME} component={DashboardLayoutContainer} />
          <Route path={ERROR_GLITCH} exact component={ErrorNotFoundContainer} />
          <Route component={ErrorNotFoundContainer} />
        </Switch>
      </Suspense>
    </ConfigProvider>
  );
};

export default App;
